module.exports = __webpack_public_path__ + "img/bg-1.229d6808.jpg";